<template>
  <Drawer
    v-model="modalShow"
    title="详情"
    :width="80"
    @on-visible-change="drawerClose"
  >
    <div class="search-block">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
      >
        <Row class="relative" type="flex" flex="end">

          <FormItem label="">
            <Input
              v-model="selectTypeClassInput"
              placeholder="请输入"
              clearable
              class="search-selectInput-430"
            >
              <Select
                slot="prepend"
                v-model="selectTypeClass"
                class="search-select-430"
                placeholder="请选择班级名称/ID"
              >
                <Option
                  v-for="(item,index) in selectTypeClassList"
                  :key="item.key+index"
                  :value="item.key"
                >{{ item.name }}</Option>
              </Select>
            </Input>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="formData.recSts"
              placeholder="处理结果"
              class="search-select-430"
              clearable
            >
              <Option
                v-for="item in statusList"
                :key="item.value"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <Button
            type="primary"
            style="margin-right: 16px"
            @click="handleSearch"
          >查询</Button>
        </Row>
      </Form>
    </div>
    <div class="table-main">
      <Table border :columns="tableColumn" :data="tableDataShow" :loading="tableLoading">

        <template slot="curClassTimeBegin" slot-scope="{ row }">
          {{ row.curClassTimeBegin | showWeekDay }}
        </template>
        <template slot="newClassTimeBegin" slot-scope="{ row }">
          {{ row.newClassTimeBegin | showWeekDay }}
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName">
          </TablePoptip>
        </template>
        <template slot="recSts" slot-scope="{ row }">
          <div class="recSts-box">
            <span :class="statusColor[row.recSts]">{{ statusFill[row.recSts] }}</span>
            <Spin v-if="row.recSts===0">
              <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            </Spin>
          </div>

        </template>
        <template slot="remark" slot-scope="{ row }">
          <div class="remark-text">{{ row.remark }}</div>
        </template>

      </Table>
    </div>
    <div class="page-wrap">
      <Page class="page-right" :total="pageInfo.total" show-sizer show-elevator show-total :current="pageInfo.pageNum" :page-size-opts="pageSizeOpts" @on-change="handlePageChange" @on-page-size-change="handlePageSize"></Page>
    </div>
  </Drawer>
</template>
<script>
import axios from 'axios';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { changeDictionaries } from '@/utils/dictionary.js';
export default {
  filters: {
    showWeekDay(date) {
      const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      if (date) {
        const newTime = /\d{4}-\d{2}-\d{2}/g.exec(date);

        return `${newTime[0]}（${week[new Date(date).getDay()]}）`;
      } else {
        return '-';
      }
    }
  },
  data() {
    return {
      modalShow: false,
      formData: {
        recSts: '',
        classroomId: '',
        classroomName: ''
      },
      searchData: {},
      statusList: [
        {
          label: '执行中',
          value: '0',
          bg: 'recSts-dealing'
        },
        {
          label: '已完成',
          value: '1',
          bg: 'recSts-done'
        },
        {
          label: '处理失败',
          value: '2',
          bg: 'recSts-dealfail'
        }
      ], // 0-执行中 1-完成 2-失败
      statusColor: {
        0: 'pass-status-430',
        1: 'normal-status-430',
        2: 'stop-status-430'
      },
      selectTypeClassInput: '', // 输入的
      selectTypeClass: '1', // 选择种类之后输入的
      selectTypeClassList: [
        {
          name: '班级名称',
          key: '1'
        },
        {
          name: '班级ID',
          key: '2'
        }
      ],
      tableColumn: [
        {
          title: '学校',
          key: 'schoolName',
          minWidth: 220
        },
        {
          title: '学期',
          key: 'yearTermName',
          minWidth: 210
        },
        {
          title: '班级ID',
          key: 'classroomId',
          minWidth: 200
        },
        {
          title: '班级名称',
          slot: 'classroomName',
          minWidth: 240
        },
        {
          title: '原上课日期',
          slot: 'curClassTimeBegin',
          minWidth: 180
        },
        {
          title: '调整后上课日期',
          slot: 'newClassTimeBegin',
          minWidth: 180
        },
        {
          title: '处理结果',
          slot: 'recSts',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 180
        },
        {
          title: '处理完成时间',
          key: 'recStsTime',
          minWidth: 180
        },
        {
          title: '备注',
          slot: 'remark',
          minWidth: 200
        }
      ],
      tableData: [],
      tableLoading: false,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      pageSizeOpts: [10, 20, 50, 100],
      batchId: '',
      loadingSource: null,
      fileIdsInfo: {},
      errObj: {},
      batchIdAndbusiObjId: {},
      createLoading: false,
      showStatusLoading: false
    };
  },
  computed: {
    statusFill() {
      return changeDictionaries(this.statusList);
    },
    recStsColorObj() {
      return changeDictionaries(this.statusList, 'bg');
    },
    tableDataShow() {
      return this.tableData.map(item => {
        return {
          ...item,
          recSts: this.fileIdsInfo[this.batchIdAndbusiObjId[item.recId]] ? this.fileIdsInfo[this.batchIdAndbusiObjId[item.recId]].recSts : item.recSts,
          remark: this.fileIdsInfo[this.batchIdAndbusiObjId[item.recId]] && this.fileIdsInfo[this.batchIdAndbusiObjId[item.recId]].prcSts === 3 ? this.fileIdsInfo[this.batchIdAndbusiObjId[item.recId]].msg : (this.errObj[item.recId] ? this.errObj[item.recId] : '')
        };
      });
    }
  },
  destroyed() {
    console.log('销毁数据--');
    this.cancelLoading();
  },
  methods: {
    drawerClose(status) {
      if (!status) {
        this.cancelLoading();
        this.$emit('refreshData');
      }
    },
    cancelLoading() {
      this.loadingSource ? this.loadingSource.cancel('取消请求') : '';
    },
    // 根据recId获取任务列表
    async getTaskList(list) {
      const recIds = list.map(item => {
        return item.recId;
      });

      return new Promise(async(resolve, reject) => {
        try {
          const res = await courseSchedulCenter.getTaskStatusListApi({
            busiObjIds: recIds,
            // procStsList: [0, 1, 2, 3],
            pageNo: 1,
            pageSize: recIds.length
          });
          if (res.status === 200) {
            console.log(res.message, '拿到的');
            const errObj = {};
            const batchIds = [];
            res.message.list.forEach(item => {
              const { batchProcData } = item;
              if (batchProcData.procSts === 3) {
                errObj[batchProcData.busiObjId] = batchProcData.lineData3;
              }
              if (batchProcData.procSts !== 1 && batchProcData.procSts !== 3) {
                batchIds.push(batchProcData.batchId);
                this.batchIdAndbusiObjId[batchProcData.busiObjId] = batchProcData.batchId;
              }
            });
            resolve(errObj);
            this.getLoadingTaskProgressList(batchIds);
          } else {
            resolve({});
          }
        } catch (err) {
          resolve({});
        }
      });
    },
    // 获取成功的任务
    async getLoadingTaskProgressList(branchIds, showTips = false) {
      if (branchIds.length === 0) {
        this.showStatusLoading = false;
        return;
      }
      const params = {
        batchIds: branchIds, // 任务id
        returnThreshold: 10 // 默认全部完成返回，百分比
      };
      this.loadingSource = axios.CancelToken.source();
      // try{

      // }catch(err){

      // }
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.loadingSource.token);
      if (res.status === 200) {
        const loadingIds = [];
        res.message.forEach(item => {
          if (item.prcSts === 1 || item.prcSts === 3) {
            // this.fileIdsInfo[item.batchId] = {
            //   ...item,
            //   recSts: item.prcSts === 3 ? 2 : item.prcSts
            // };
            this.$set(this.fileIdsInfo, item.batchId, {
              ...item,
              recSts: item.prcSts === 3 ? 2 : item.prcSts
            });
            console.log(this.fileIdsInfo, '拿到的数据---');
          } else {
            loadingIds.push(item.batchId);
          }
        });
        this.showStatusLoading = loadingIds.length > 0;
        this.showStatusLoading ? this.getLoadingTaskProgressList(loadingIds, showTips) : '';
      } else {
        this.getLoadingTaskProgressList(branchIds, showTips);
      }
    },
    openModal(id) {
      this.selectTypeClassInput = '';
      this.selectTypeClass = '1';
      this.formData.recSts = '';
      this.modalShow = true;
      this.batchId = id;
      this.handleSearch();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getDetailsList();
    },
    handlePageChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getDetailsList();
    },
    handleSearch() {
      this.formData.classroomId = '';
      this.formData.classroomName = '';
      this.searchData = {};
      if (this.selectTypeClass === '1') {
        this.formData.classroomName = this.selectTypeClassInput;
      }
      if (this.selectTypeClass === '2') {
        this.formData.classroomId = this.selectTypeClassInput;
      }
      Object.keys(this.formData).forEach(item => {
        if (this.formData[item]) {
          this.searchData[item] = this.formData[item];
        }
      });
      this.pageInfo.pageNum = 1;
      this.getDetailsList();
    },
    async getDetailsList() {
      this.tableLoading = true;
      this.cancelLoading();
      try {
        const res = await courseSchedulCenter.adjustCourseTimeRecsDetailsListApi({ batchId: this.batchId, ...this.searchData, pageNum: this.pageInfo.pageNum, pageSize: this.pageInfo.pageSize });
        if (res.status === 200) {
          this.tableData = res.message.list;
          this.pageInfo.total = +res.message.total;
          if (res.message.list && res.message.list.length > 0) {
            this.errObj = await this.getTaskList(res.message.list);
          }
        }
      } finally {
        this.tableLoading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.search-block{
  margin-bottom: 20px;
}
.remark-text{
  color: rgb(217, 0, 27);
  line-height: 20px;
}
.recSts-box{
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo-spin-icon-load{
  margin-left: 10px;
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
</style>
